angular.module('storefrontApp')
    .component('vcCreditCard', {
        templateUrl: 'themes/assets/js/common-components/creditCard.tpl.html',
        bindings: {
            card: '=',
            validationContainer: '=',
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
            const ctrl = this;

            this.$onInit = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.addComponent(this);
                }
            };

            this.$onDestroy = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.removeComponent(this);
                }
            };

            $scope.$watch('$ctrl.card.bankCardHolderName', function (val) {
                if (ctrl.card) {
                    ctrl.card.bankCardHolderName = $filter('uppercase')(val);
                }
            }, true);

            ctrl.validate = function () {
                ctrl.form.$setSubmitted();
                return !ctrl.form.$invalid;
            };
        }],
    });
